var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "BigScheme" }, [
    _setup.hasSvg
      ? _c("div", { staticClass: "legend" }, [
          _c("div", { staticClass: "legend-ul" }, [
            _setup.bookMode
              ? _c("div", { staticClass: "legend-li" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "scheme legend-li--scheme",
                      attrs: {
                        width: "30",
                        height: "30",
                        viewBox: "0 0 30 30",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("g", { staticClass: "SelectorG any" }, [
                        _c("rect", {
                          staticClass: "cabin",
                          attrs: { x: "0", y: "0", width: "30", height: "20" },
                        }),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "cabin_num",
                            attrs: {
                              "text-anchor": "middle",
                              transform: "translate(15,15)",
                              "text-rendering": "geometricPrecision",
                            },
                          },
                          [_vm._v("11")]
                        ),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "cabin_vacancies",
                            attrs: {
                              "text-anchor": "middle",
                              transform: "translate(15,30)",
                            },
                          },
                          [_vm._v("2+1")]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "legend-li--desc" }, [
                    _vm._v("каюта занята"),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _setup.bookMode
              ? _c("div", { staticClass: "legend-li" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "scheme legend-li--scheme",
                      attrs: {
                        width: "30",
                        height: "30",
                        viewBox: "0 0 30 30",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("g", { staticClass: "SelectorG free" }, [
                        _c("rect", {
                          staticClass: "cabin",
                          attrs: { x: "0", y: "0", width: "30", height: "20" },
                        }),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "cabin_num",
                            attrs: {
                              "text-anchor": "middle",
                              transform: "translate(15,15)",
                              "text-rendering": "geometricPrecision",
                            },
                          },
                          [_vm._v("22")]
                        ),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "cabin_vacancies",
                            attrs: {
                              "text-anchor": "middle",
                              transform: "translate(15,30)",
                            },
                          },
                          [_vm._v("2+1")]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "legend-li--desc" }, [
                    _vm._v("каюту можно бронировать"),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _setup.bookMode
              ? _c("div", { staticClass: "legend-li" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "scheme legend-li--scheme",
                      attrs: {
                        width: "30",
                        height: "30",
                        viewBox: "0 0 30 30",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("g", { staticClass: "SelectorG free prebook" }, [
                        _c("rect", {
                          staticClass: "cabin",
                          attrs: { x: "0", y: "0", width: "30", height: "20" },
                        }),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "cabin_num",
                            attrs: {
                              "text-anchor": "middle",
                              transform: "translate(15,15)",
                              "text-rendering": "geometricPrecision",
                            },
                          },
                          [_vm._v("33")]
                        ),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "cabin_vacancies",
                            attrs: {
                              "text-anchor": "middle",
                              transform: "translate(15,30)",
                            },
                          },
                          [_vm._v("2ч")]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "legend-li--desc" }, [
                    _vm._v("размещено 2 гостя"),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_setup.bookMode
              ? _c("div", { staticClass: "legend-li" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "scheme legend-li--scheme",
                      attrs: {
                        width: "30",
                        height: "30",
                        viewBox: "0 0 30 30",
                        xmlns: "http://www.w3.o+rg/2000/svg",
                      },
                    },
                    [
                      _c("g", {}, [
                        _c("rect", {
                          staticClass: "cabin",
                          staticStyle: { fill: "rgb(168, 182, 255)" },
                          attrs: { x: "0", y: "0", width: "30", height: "20" },
                        }),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "cabin_num",
                            attrs: {
                              "text-anchor": "middle",
                              transform: "translate(15,15)",
                              "text-rendering": "geometricPrecision",
                            },
                          },
                          [_vm._v("44")]
                        ),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "cabin_vacancies",
                            attrs: {
                              "text-anchor": "middle",
                              transform: "translate(15,30)",
                            },
                          },
                          [_vm._v("2+1")]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "legend-li--desc" }, [
                    _vm._v("одна цена - один цвет"),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _setup.hasScheme
      ? _c("div", { staticClass: "win" }, [
          _c(
            "div",
            { staticClass: "win-core", class: { svg: _setup.hasSvg } },
            [
              _c(
                "div",
                {
                  ref: "rootScheme",
                  staticClass: "win-core--scheme",
                  class: { svg: _setup.hasSvg },
                  style: _setup.schemeStyle,
                },
                [
                  !_setup.hasSvg
                    ? _c("img", { attrs: { src: _setup.scheme_jpg } })
                    : _vm._e(),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "win-tools" }, [
            _c(
              "button",
              {
                staticClass: "win-tools--plus",
                on: { click: _setup.zoomPlus },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11 5.992c0-.537.448-.992 1-.992.556 0 1 .444 1 .992V11h5.008c.537 0 .992.448.992 1 0 .556-.444 1-.992 1H13v5.008c0 .537-.448.992-1 .992-.556 0-1-.444-1-.992V13H5.992C5.455 13 5 12.552 5 12c0-.556.444-1 .992-1H11V5.992z",
                        fill: "currentColor",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "win-tools--minus",
                on: { click: _setup.zoomMinus },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z",
                        fill: "currentColor",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          !_setup.schemeDim.loaded
            ? _c(
                "div",
                { staticClass: "win-load" },
                [_c(_setup.Loader, { staticClass: "win-load--loader" })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.schemeDim.error
            ? _c("div", { staticClass: "win-load" }, [
                _vm._v("Не удалось загрузить схему"),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "legend-li" }, [
      _c("span", { staticClass: "legend-li--scheme cabivac" }, [_vm._v("2+1")]),
      _vm._v(" "),
      _c("span", { staticClass: "legend-li--desc" }, [
        _vm._v("основных мест + дополнительных"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }